import DoctorItemSkeleton from './doctor-item.skeleton';

export default DoctorItemSkeleton;
